import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-darkGreen text-white relative overflow-hidden">
      {/* World Map Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 10h80v80H10z' fill='none' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E")`,
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold font-serif">GrowthLink</span>
              <span className="w-2 h-2 bg-accent rounded-full"></span>
            </div>
            <p className="text-2xl font-serif leading-relaxed text-white/90">
              Transforming Businesses Through Digital Excellence
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white placeholder-white/60 focus:outline-none focus:border-secondary text-sm"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-accent rounded-full hover:bg-accent/80 transition-colors">
                <i className="ri-notification-line text-white text-lg"></i>
              </button>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">SEO Optimization</Link></li>
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">Social Media Marketing</Link></li>
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">Content Strategy</Link></li>
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">PPC Advertising</Link></li>
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">Business Consultancy</Link></li>
              <li><Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">B2B Marketing</Link></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-white/70 hover:text-white transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/enquiry" className="text-sm text-white/70 hover:text-white transition-colors">Free Audit</Link></li>
              <li><Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">Marketing Guide</Link></li>
              <li><Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">Webinars</Link></li>
              <li><Link to="/enquiry" className="text-sm text-white/70 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-dark">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-primary mt-1"></i>
                <span className="text-gray-600 text-sm">
                  Growthlink Marketing Solutions<br />
                  Serlingampally<br />
                  Hyderabad 500082
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-global-line text-xl text-primary mt-1"></i>
                <span className="text-gray-600 text-sm">
                  Serving India, USA, UK, UAE & Qatar
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-xl text-primary"></i>
                <a href="tel:+918931893177" className="text-gray-600 text-sm hover:text-primary transition-colors">
                  +91 8931893177
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-xl text-primary"></i>
                <a href="mailto:growthlink2705@gmail.com" className="text-gray-600 text-sm hover:text-primary transition-colors">
                  growthlink2705@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-white/70">
            © {currentYear} GrowthLink. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors">
              <i className="ri-facebook-fill text-white"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors">
              <i className="ri-twitter-x-line text-white"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors">
              <i className="ri-linkedin-fill text-white"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors">
              <i className="ri-instagram-line text-white"></i>
            </a>
          </div>

          <div className="flex items-center gap-4 text-xs text-white/70">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span>|</span>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">Cookie Policy</Link>
            <span>|</span>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            <span>|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Growthlink</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
